import ApiV2 from './api-v2';

export interface GeneratedSegmentFragment {
  id: number;
  workerId: string;
  fragmentName: string;
  sequenceNumber: number;
  type: string;
  timeStart: number;
  timeEnd: number;
}

interface ApiEnvelope<T> {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
}

interface GenerateSegmentsData {
  fragments: GeneratedSegmentFragment[];
}

/**
 * Generates N new segment fragments for a worker via the eos-app endpoint.
 * Sequence numbers continue from the worker's current segment count; each new
 * segment is 120s long with a 120s gap.
 */
export async function generateSegmentFragments(
  workerId: string,
  numberOfSegments: number,
): Promise<GeneratedSegmentFragment[]> {
  const response = await ApiV2.post<ApiEnvelope<GenerateSegmentsData>>('/api/fragments/segments', {
    workerId,
    numberOfSegments,
  });
  if (!response.success || !response.data) {
    throw new Error(response.error || 'Failed to generate segments');
  }
  return response.data.fragments;
}
